import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { NavigateBefore as PrevIcon, NavigateNext as NextIcon } from '@mui/icons-material';

/**
 * Renders ‹ N / total › arrows for navigating through a list from a detail page.
 * Receives the IDs array + current index from React Router location.state and
 * calls onPrev / onNext when the user clicks an arrow.
 */
const ListNavigation = ({ ids = [], index = -1, onPrev, onNext }) => {
  if (ids.length === 0 || index < 0) return null;

  const hasPrev = index > 0;
  const hasNext = index < ids.length - 1;

  return (
    <Box display="flex" alignItems="center" sx={{ flexShrink: 0 }}>
      <IconButton size="small" onClick={onPrev} disabled={!hasPrev} aria-label="previous">
        <PrevIcon />
      </IconButton>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ minWidth: 40, textAlign: 'center', userSelect: 'none' }}
      >
        {index + 1} / {ids.length}
      </Typography>
      <IconButton size="small" onClick={onNext} disabled={!hasNext} aria-label="next">
        <NextIcon />
      </IconButton>
    </Box>
  );
};

export default ListNavigation;
